<template>
  <remediation />
</template>
<script setup lang="ts">
import Remediation from "./Remediation.vue";
</script>
